import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { CARTS_BASE_PATH } from '@nike/cart-constants';
import { NIKE_API_HOST } from '@nike/ux-tread-dotcom-constants';
import { fetchClient, formatHeaders } from '@nike/fetch-client';

/**
 * NOTE - re: magic visitor id - sigh.
 * the below value is used for passing to a patch call to carts v2 in order to have
 * backend validate and fix the cart when we don't know how to fix it on the front-end.
 * We use it to create a validateOnly flag for the mergeCartsByParams function.
 */
export var MAGIC_VISITOR_ID = '00000000-0000-0000-0000-000000000000';

/**
 * mergeCartsByParams adds or removes a line item or promotion code from a user’s cart
 * using filters in url path
 *
 * @param {object} params - named parameters
 * @param  {string} params.appId - appId provided by client app (unite uxid)
 * @param  {string} params.token - user auth token (ux-tread-unite-redux getAuthToken)
 * @param  {string} params.visitId - user visitId (ux-tread-unite-redux getVisitId)
 * @param  {string} params.visitorId - user visitorId (ux-tread-unite-redux getVisitorId)
 * @param  {string} params.brand - brand by default is Nike but can by for ex: Hurley
 * @param  {string} params.channel - channel by default for web is NIKECOM
 * @param  {string} params.country - country defaults to US (ux-tread-localization getCountry)
 * @param  {boolean} params.validateOnly - boolean to indicate to service to validate the cart only
 * @param {string} [params.host=NIKE_API_HOST] - host value to be used in url fetching cart from, in case it needs to be modified for mocking* @param {string} [params.host=NIKE_API_HOST] - host value to be used in url fetching cart from, in case it needs to be modified for mocking
 * @param {object} params.fetchOptions - options to pass down to fetch
 * @param {string} [params.modifiers='VALIDATELIMITS,VALIDATEAVAILABILITY'] - modifiers for PATCH call to carts service
 * @param {string} params.fields - fields query params for PATCH call to carts service
 * @returns {Promise} fetch promise
 */
export default function mergeCartsByParams(_ref) {
  var appId = _ref.appId,
    token = _ref.token,
    visitId = _ref.visitId,
    visitorId = _ref.visitorId,
    brand = _ref.brand,
    channel = _ref.channel,
    country = _ref.country,
    _ref$host = _ref.host,
    host = _ref$host === void 0 ? NIKE_API_HOST : _ref$host,
    validateOnly = _ref.validateOnly,
    _ref$modifiers = _ref.modifiers,
    modifiers = _ref$modifiers === void 0 ? 'VALIDATELIMITS,VALIDATEAVAILABILITY' : _ref$modifiers,
    fields = _ref.fields,
    fetchOptions = _ref.fetchOptions;
  var url = "".concat(host, "/").concat(CARTS_BASE_PATH, "/").concat(country.toUpperCase(), "/").concat(brand, "/").concat(channel, "?modifiers=").concat(modifiers);
  if (fields) {
    url = "".concat(host, "/").concat(CARTS_BASE_PATH, "/").concat(country.toUpperCase(), "/").concat(brand, "/").concat(channel, "?modifiers=").concat(modifiers, "&fields=").concat(fields);
  }
  var finalId = validateOnly ? MAGIC_VISITOR_ID : visitorId;
  var body = JSON.stringify([{
    op: 'merge',
    path: '/',
    value: {
      visitorId: finalId
    }
  }]);
  return fetchClient(url, _objectSpread({
    headers: formatHeaders({
      token: token,
      visitId: visitId,
      visitorId: visitorId,
      appId: appId
    }),
    method: 'PATCH',
    credentials: 'include',
    body: body
  }, fetchOptions), 'Error merging carts by filter', {
    pageActionName: 'tread-cart-event'
  });
}